export default __webpack_public_path__ + "static/media/cg.8d1fe34d.jpg";